<script>
import AppActionButton from '@/components/AppActionButton'
import { mapActions, mapGetters, mapState } from 'vuex'
const { isVisualizarGestaoProcessos, separatorByUnderscore, criarModelos } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  data () {
    return {
      isVisualizarGestaoProcessos: false
    }
  },

  components: {
    AppActionButton
  },

  props: {
    notificacao: {
      type: Boolean,
      default: true
    },

    hasListagemModelo: {
      type: Boolean,
      default: true
    },

    hasNotificacaoModulo: {
      type: Boolean,
      default: false
    },
    isManutencao: {
      type: Boolean,
      require: false,
      default: false
    }
  },

  created () {
    this.isVisualizarGestaoProcessos = isVisualizarGestaoProcessos(this.usuario?.perfilSelecionado?.codigo)
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    ...mapState({
      LOGO: state => state.userInterface.dadosEstado.LOGO
    }),

    hasNotificacao () {
      return this.usuario && this.notificacao
    },

    hasPermissaoCriarModelos () {
      return !criarModelos.perfisExcluidos.includes(separatorByUnderscore(this.usuario.perfilSelecionado.codigo)) ||
      criarModelos.perfisExcecoes.includes(this.usuario.perfilSelecionado.codigo)
    },

    nomeUsuario () {
      if (!this.usuario) {
        return '-'
      }

      return this.usuario.pessoa.nomeRazaoSocial
    },

    getUrlMeusDados () {
      return process.env.URL_MODULO_GESTAO_DADOS
    },

    nomePerfil () {
      if (!this.usuario) {
        return '-'
      }

      return this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.nome : null
    }
  },

  methods: {
    ...mapActions({
      clearPerfil: 'auth/clearPerfil'
    }),

    perfisWithOutNotificacao (setor) {
      const perfisWithOutNotificacao = ['CENTRAL_DO_INTERESSADO', 'FINANCEIRO', 'PORTAL_DE_SEGURANCA', 'RELATORIOS']
      return perfisWithOutNotificacao.includes(setor)
    },

    async sair () {
      if (this.$route.name === 'selecionarModulo') {
        this.$router.push({ name: 'logout' })
      } else if (this.$route.name === 'selecionarPerfil' || this.usuario.qtdPerfis === 1) {
        this.$router.push({ name: 'selecionarModulo' })
      } else {
        this.$router.push({ name: 'selecionarPerfil' })
      }
    },

    goToGestaoProcesso () {
      this.$router.push({ name: 'gestao-processo-usuario' })
    },

    goToListagemModelos () {
      if (!this.isManutencao) {
        this.$router.push({ name: 'listagem-modelos-despacho-notificacao' })
      } else {
        this.$router.push({ name: 'listagem-modelos-despacho-notificacao-manutencao' })
      }
    },

    goHome () {
      this.$router.push({ name: this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.paginaInicial : 'selecionarModulo' })
    },

    getPrimeiroEUltimoNome (nomeCompleto) {
      const partes = nomeCompleto.trim().split(/\s+/)
      const primeiroNome = partes[0]
      const ultimoNome = partes[partes.length - 1]
      return `${primeiroNome} ${ultimoNome}`
    }
  }
}
</script>

<template>
  <div>
    <div class="topo">
      <img
        id="logo"
        :src="LOGO"
        alt="sicarf"
        name="logo"
        @click="goHome"
      />

      <div class="info">
        <template v-if="hasListagemModelo">
          <div class="el-dropdown-link" v-if="isVisualizarGestaoProcessos">
            <el-tooltip
              id="tooltip"
              effect="dark"
              content="Gestão processos/usuários"
              placement="bottom"
            >
              <font-awesome-icon @click="goToGestaoProcesso" icon="user-friends" />
            </el-tooltip>
          </div>
        </template>

        <div class="user" v-if="!$route.meta.isPublic">
          <div class="usuario">
            <i class="fas fa-user-circle"></i>
            <div class="descricao">
              <span class="nomePerfil" v-if="nomeUsuario">
                &nbsp;{{ getPrimeiroEUltimoNome(nomeUsuario) }}
              </span>
              <span class="nomePerfil" v-if="nomePerfil">
                &nbsp;{{ nomePerfil }}
              </span>
            </div>
          </div>

          <div class="logout">
            <app-action-button
              icone="sign-out-alt"
              id="button_logout"
              @click="sair"
              cor="#a7b2bb"
              text="Sair"
              fontSize="25"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.topo {
  width: 100%;
  height: $header-size;
  display: flex;
  align-items: center;
  padding: 0 5% 0 5%;
  justify-content: space-between;
  background-color: #f3f7fa;
  font-size: xx-large;
  border-bottom: solid 1px #eaeef1;

  .el-dropdown-link {
    cursor: pointer;
    margin-right: 0.5em;
    color: $lightgray-color;
  }

  .pesquisaGeral {
    cursor: pointer;
    margin-right: 2em;
  }

  .el-dropdown-link:hover {
    transition: color 0.3s;
    color: $color-primary;
  }

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .light {
    color: $lightgray-color;
  }

  span {
    font-size: 15px;
    color: #424242;
  }

  #logo {
    height: 100%;
    width: auto;
    cursor: pointer;
  }

  .user {
    display: flex;
    align-items: center;
    color: #a7b2bb;
    justify-content: space-between;

    .usuario {
      display: flex;
      align-items: center;
      .descricao {
        text-align: left;
        display: flex;
        flex-direction: column;
        .nomePerfil {
          opacity: 0.8;
        }
      }
    }
    .logout {
      margin-left: 1vw;
      display: flex;
      align-items: center;
      font-size: 15px;
      .icon {
        font-size: inherit !important;
      }
    }
  }
}

@media (max-width: 780px) {
  .topo {
    display: block;
    height: 130px !important;
    #logo {
      height: 35% !important;
      position: relative;
      right: 15px;
      top: 60px;
    }

    .info {
      flex-wrap: initial !important;
    }
    .el-dropdown-link {
      position: relative;
      top: 20px;
      left: 185px;
    }

    .listagemModelo {
      position: relative;
      top: 10px;
    }

    .notificacaoUser {
      top: 20px;
      left: 180px
  ;
    }
    .user {

      .logout {
        position: relative;
        bottom: 45px;
        right: 45px;
      }

      .usuario {
        position: relative;
        bottom: 40px;
        right: 60px;
        .descricao{
          position: relative;
          left: 15px;
          flex-direction: row;
        }
      }
    }
  }
}

@media (max-width: 1256px) {
  .topo {
    height: 90px;

    #logo {
      height: 50%;
    }
    .user .usuario .descricao {
      padding-left: 13px
    }

    .info {
      flex-wrap: wrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue